import React, {useEffect, useState} from 'react'
import styles from './matrix-list-style.module.css'
import { getUpcomingMatrices } from '../firebase/firebase'

function MartixEntry({data}) {
    var startDate = new Date(data.start_date.seconds * 1000);
    var endDate = new Date(data.end_date.seconds * 1000);

    var formatedStartDate = startDate.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
    var formattedEndDate  = endDate.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});

    var headers = ['Start Date:', 'End Date:', 'Expected Attendance:'];
    var rowData = [formatedStartDate, formattedEndDate, data.expected_attendance + " Guests"]

    if(data.live_registration != null) {
        headers[2] = 'Expected:'
        headers.push("Live Count: ");
        rowData.push(data.live_registration + " Guests");
    }

    return (
        <div className={styles.entry}>
            <div className={styles.matrix_header}>
                <h2 className={styles.name_header}>{data.name}</h2>
                <h2 className={styles.percentage_header}>{(data.matrix_completion * 100).toFixed(2) + '%'}</h2>
            </div>            
            <div className={styles.data}>
                <table>
                    <thead>
                        <tr>{headers.map(header => <th key={header}>{header}</th>)}</tr>
                    </thead>
                    <tbody>
                        <tr>
                            {rowData.map(dataItem => <td key={dataItem}>{dataItem}</td>)}
                        </tr>
                    </tbody>                             
                </table>
                <a target='_blank' rel="noreferrer" href={data.matrix_link}>Link to Matrix</a>
            </div>            
        </div>
    );
}



function MatrixList({ setShowNavBar }) {

    const [upcomingGroups, setUpcomingGroups] = useState([]);
    const [visibleEventTypes, setVisibleEventTypes] = useState({'camp': true, 'retreat': true, 'day_event': true, 'reservation': true, 'tests': false});

    useEffect(() => setShowNavBar(true));

    useEffect(() => {
        async function getList() {
            let data = await getUpcomingMatrices();    
            var groups = [];
    
            for(const d in data) {

                if(visibleEventTypes.tests || !data[d].id.startsWith('test'))
                    groups = [...groups, {'groupId':d, 'groupData':data[d]}];
            }

            groups.sort((a, b) => a.groupData.start_date - b.groupData.start_date)

            return groups;
        }

        getList().then( (groups) => {
            setUpcomingGroups(groups);
        });
    }, []);


    return (
        
        <div className={styles.list}>
            <h1>Upcoming Matrices</h1>
            {upcomingGroups.map(input => <MartixEntry key={input.groupId} data={input.groupData} />)}
        </div>
    )
}

export default MatrixList